import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: false,
    user: null,
    userLoading: true,
    microsoftUser: false,
    boclipsUser: null
  },
  reducers: {
    loginUser: (state, action) => {
      const { payload } = action;

      state.isAuthenticated = true;
      state.user = payload.user;
      state.userLoading = false;
    },
    logoutUser: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.userLoading = false;
      // remove all localStorage Cache from API calls. Any storage item 
      // with sooth in the key will be deleted.
      for (let key in localStorage) {
        if (!localStorage.hasOwnProperty(key) || !key.includes("sooth")) {
          continue;
        }
        // console.log(key, localStorage[key]);
        localStorage.removeItem(key);
      }
    },
    setMicrosoftUser: (state, action) => {
      const { payload } = action;
      state.microsoftUser = payload;
    },
    setBoclipsUser: (state, action) => {
      const { payload } = action;
      state.boclipsUser = payload;
    }
  },
});

// this is for dispatch
export const { loginUser, logoutUser, setMicrosoftUser, setBoclipsUser } =
  authSlice.actions;

// this is for configureStore
export default authSlice.reducer;
